import { ApiError } from '@getslot/api-client'
import { Button } from '@getslot/ui-web/button'
import { Notice } from '@getslot/ui-web/notice'
import type { ErrorComponentProps } from '@tanstack/react-router'

/** Ошибка роута: текст без технических деталей и кнопка повтора. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const offline = error instanceof ApiError && error.isUnavailable
  return (
    <Notice
      title={offline ? 'Нет связи' : 'Что-то сломалось'}
      actions={
        <Button variant="cta" onClick={reset}>
          Попробовать ещё раз
        </Button>
      }
    >
      {offline ? 'Сервер не отвечает. Проверьте интернет или зайдите чуть позже.' : 'Мы уже видим ошибку в логах.'}
    </Notice>
  )
}
